import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import {
  ConfirmationPopup,
  IConfirmationPopupDynamicProps,
} from "component-library";
import VideoOverlayPopup, {
  IVideoOverlayPopupProps,
} from "shared/components/Video/VideoOverlayPopup/VideoOverlayPopup";

import { IApplicationState } from "store";
import { IPopup, PopupType } from "store/ui/ui.types";

import ErrorPopup, {
  IErrorPopupDynamicProps,
} from "components/Popups/ErrorPopup/ErrorPopup";

import ReportConcernPopup, {
  IReportConcernPopupDynamicProps,
} from "./ReportConcernPopup/ReportConcernPopup";

const Popups = (): React.ReactElement | null => {
  const popup: IPopup | null = useSelector(
    (state: IApplicationState) => state.ui.popup,
    shallowEqual
  );

  if (!popup) {
    return null;
  }

  const data = popup.data || {};
  const { supportErrorCodeLabel } = data as IErrorPopupDynamicProps;

  switch (popup.type) {
    case PopupType.ErrorPopup:
      return (
        <ErrorPopup
          {...(data as IErrorPopupDynamicProps)}
          supportErrorCodeLabel={
            popup.traceID && supportErrorCodeLabel
              ? `${supportErrorCodeLabel} ${popup.traceID}`
              : undefined
          }
        />
      );
    case PopupType.ReportConcernPopup:
      return (
        <ReportConcernPopup {...(data as IReportConcernPopupDynamicProps)} />
      );
    case PopupType.ConfirmationPopup:
      return (
        <ConfirmationPopup {...(data as IConfirmationPopupDynamicProps)} />
      );
    case PopupType.VideoOverlayPopup:
      return <VideoOverlayPopup {...(data as IVideoOverlayPopupProps)} />;
    default:
      return null;
  }
};

export default Popups;
